
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'PenileCancer_TNM',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/PenileCancer_TNM.vue